import { useState, useEffect } from "react";
import { useSupabaseApp } from "../../SupabaseApp";
import { Modal } from "react-bootstrap";
import ApplicationModal from "./application-modal";

/**
 * The `ApplicationButton` component renders a button that either opens a modal or redirects to a
 * specific URL based on the user's tier level.
 * @returns The `ApplicationButton` component is being returned. It consists of conditional rendering
 * based on the `popout` state, which determines whether to render a button that opens a popout URL or
 * a button that opens a modal. The component also includes a modal from `react-bootstrap` that
 * displays an `ApplicationModal` component when opened.
 */

const ApplicationButton = ({ title }) => {
  const { getUserTier } = useSupabaseApp();

  const [show, setShow] = useState(false);

  const [modal, setModal] = useState("");

  const [popout, setPopout] = useState(false);

  const [popoutUrl, setPopoutUrl] = useState("");

  // Set up the <script> element
  useEffect(() => {
    // Initialize script
    const script = document.createElement("script");
    script.src = "https://iw.lendflow.com/js/lendflow-loader.js";
    script.async = true;

    // Add the script inside the <body> element
    document.body.appendChild(script);

    // Prints the <body> element in the console. You should be able to see the <script> element that was added
    // console.log(document.body);

    // Cleanup function to remove the script on component unmount, e.g. when the user exits
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Set up the Popout URL
  useEffect(() => {
    const url = "https://iw.lendflow.com";

    const params = {
      env: process.env.REACT_APP_LF_ENV,
      viewProduct: "1",
      brandId: process.env.REACT_APP_LF_BRAND_ID,
      workflowTemplateId: process.env.REACT_APP_LF_WORKFLOW_TEMPLATE_ID,
      emailTemplateId: process.env.REACT_APP_LF_EMAIL_TEMPLATE_ID,
      consentTemplateId: process.env.REACT_APP_LF_CONSENT_TEMPLATE_ID,

      "destination[mode]": "bp",
      "destination[url]": `https://borrower.lendflow.com?token=${process.env.REACT_APP_LF_DESTINATION_URL_TOKEN}&branding=${process.env.REACT_APP_LF_BRAND_ID}`,
      "destination[script_url]": `https://borrower.lendflow.com/lfbp.js?token=${process.env.REACT_APP_LF_DESTINATION_SCRIPT_URL_TOKEN}&branding=${process.env.REACT_APP_LF_BRAND_ID}`,
    };

    // Create a URL object
    const urlObj = new URL(url);

    // Add each key-value pair in the params object as a query parameter
    for (let key in params) {
      urlObj.searchParams.set(key, params[key]);
    }

    // Get the updated URL as a string
    const updatedUrl = urlObj.toString();

    // console.log("Updated URL:", updatedUrl);

    setPopoutUrl(updatedUrl);

    // Cleanup function (optional)
    return () => {
      // console.log('Cleanup for url object configuring effect');
    };
  }, []);

  // Set up visibility of the Popout
  useEffect(() => {
    const checkTier = async () => {
      const tier = await getUserTier();
      if (tier >= 3) setPopout(true);
    };

    checkTier();
  }, []);

  function openModal() {
    setShow(true);
    setModal(<ApplicationModal />);
  }

  function closeModal() {
    setShow(false);
  }

  return (
    <>
      {popout ? (
        <a href={popoutUrl}>
          <button className="glintanimation navbarideachecker">{title}</button>
        </a>
      ) : (
        <button
          className="glintanimation navbarideachecker"
          onClick={openModal}
        >
          {title}
        </button>
      )}

      <Modal
        className="modal-div"
        show={show}
        onHide={closeModal}
        fullscreen="sm-down"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {modal}
      </Modal>
    </>
  );
};
export default ApplicationButton;
